import type { Locale } from "./site";

/**
 * Shape shared by the localized data records in `src/data/` (accessories,
 * archive models, …): an English base plus optional per-locale partial overrides.
 * A missing locale or field silently falls back to English — see AGENTS.md.
 */
export type LocalizedRecord<T> = {
  en: T;
  localized?: Partial<Record<Locale, Partial<T>>>;
};

/**
 * Pick a localized field, falling back to the English base when the active
 * locale has no (non-empty) override. Centralizes the
 * `localized?.[locale]?.[field] || en[field]` pattern that was duplicated across
 * the accessory, archive, and page-SEO code paths.
 */
export function pickLocalized<T, K extends keyof T>(
  record: LocalizedRecord<T>,
  locale: Locale,
  field: K,
): T[K] {
  return (record.localized?.[locale]?.[field] || record.en[field]) as T[K];
}
